import type { BenefitRule, RuleAction, RuleOperator } from '../types/rulesEngine'
import {
  listCatalogMasters,
  listCatalogMastersQuery,
  type CatalogMasterRecord,
} from './catalogMastersService'

export type BenefitRuleFieldMasterRecord = CatalogMasterRecord
export type BenefitRuleOperatorMasterRecord = CatalogMasterRecord
export type BenefitRuleActionMasterRecord = CatalogMasterRecord
export type BenefitRuleFieldValueMasterRecord = CatalogMasterRecord

/** GET /masters/benefit-rule-fields */
export async function listBenefitRuleFields(q?: string): Promise<BenefitRuleFieldMasterRecord[]> {
  return listCatalogMasters('benefit-rule-fields', q)
}

/** GET /masters/benefit-rule-operators */
export async function listBenefitRuleOperators(
  q?: string
): Promise<BenefitRuleOperatorMasterRecord[]> {
  return listCatalogMasters('benefit-rule-operators', q)
}

/** GET /masters/benefit-rule-actions */
export async function listBenefitRuleActions(q?: string): Promise<BenefitRuleActionMasterRecord[]> {
  return listCatalogMasters('benefit-rule-actions', q)
}

/** GET /masters/benefit-rule-field-values?field_master_id= */
export async function listBenefitRuleFieldValues(
  fieldMasterId: string
): Promise<BenefitRuleFieldValueMasterRecord[]> {
  return listCatalogMastersQuery('benefit-rule-field-values', {
    field_master_id: fieldMasterId,
  })
}

export function createEmptyBenefitRule(
  fields: BenefitRuleFieldMasterRecord[],
  operators: BenefitRuleOperatorMasterRecord[],
  actions: BenefitRuleActionMasterRecord[]
): BenefitRule {
  const field = fields[0]
  const operator = operators[0]
  const passAction = actions.find((a) => a.value_key === 'continue') ?? actions[0]
  const failAction = actions.find((a) => a.value_key === 'flag') ?? actions[0]

  return {
    id: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: 'New Rule',
    field: field?.value_key ?? 'networkStatus',
    conditionFieldMasterId: field?.id,
    operator: (operator?.value_key ?? 'equals') as RuleOperator,
    conditionOperatorMasterId: operator?.id,
    value: '',
    action: (passAction?.value_key ?? 'continue') as RuleAction,
    onPassActionMasterId: passAction?.id,
    failAction: (failAction?.value_key ?? 'flag') as RuleAction,
    onFailActionMasterId: failAction?.id,
    failMessage: 'Rule failed',
  }
}
